var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 165,
    viewBox: "0 0 148 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5108_93694)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M73.8061 156.034C114.3 156.034 147.128 123.207 147.128 82.7123C147.128 42.2179 114.3 9.39062 73.8061 9.39062C33.3116 9.39062 0.484375 42.2179 0.484375 82.7123C0.484375 123.207 33.3116 156.034 73.8061 156.034Z",
    fill: "#E2FFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4122 164.55H60.318C64.237 164.55 67.4139 161.373 67.4139 157.454V143.455C67.4139 139.536 64.237 136.359 60.318 136.359H45.4122C41.4934 136.359 38.3164 139.536 38.3164 143.455V157.454C38.3164 161.373 41.4934 164.55 45.4122 164.55Z",
    fill: "#D3F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.122 67.0366H141.096C143.717 67.0366 145.843 64.9111 145.843 62.2892V52.9232C145.843 50.3013 143.717 48.1758 141.096 48.1758H131.122C128.501 48.1758 126.375 50.3012 126.375 52.9232V62.2892C126.375 64.9111 128.501 67.0366 131.122 67.0366Z",
    fill: "#FD3434",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8306 31.551H102.051C106.315 31.551 109.773 28.0941 109.773 23.8296V8.59644C109.773 4.332 106.315 0.875002 102.051 0.875001L85.8306 0.875C81.5664 0.875 78.1094 4.332 78.1094 8.59643V23.8296C78.1094 28.0941 81.5664 31.551 85.8306 31.551Z",
    fill: "#CEC2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.158 109.832H44.1612C40.5001 109.832 37.5312 106.862 37.5312 103.202V63.421C37.5312 59.7599 40.5001 56.791 44.1612 56.791H105.158C108.819 56.791 111.788 59.7599 111.788 63.421V103.202C111.788 106.862 108.819 109.832 105.158 109.832Z",
    fill: "#7FEDA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6602 74.0293L37.6445 104.316C38.1763 107.443 40.8813 109.832 44.1618 109.832H105.158C108.439 109.832 111.144 107.443 111.676 104.316L74.6602 74.0293Z",
    fill: "#2FF77A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6445 62.3072L71.7893 90.245C73.4588 91.6104 75.8602 91.6104 77.531 90.245L111.676 62.3072C111.144 59.1791 108.439 56.791 105.158 56.791H44.1618C40.8813 56.791 38.1763 59.1791 37.6445 62.3072Z",
    fill: "#A6F9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.56 117.636H115.067C118.867 117.636 121.948 114.555 121.948 110.756V97.1359C121.948 93.3362 118.867 90.2559 115.067 90.2559H100.56C96.76 90.2559 93.6797 93.3362 93.6797 97.1359V110.756C93.6797 114.555 96.76 117.636 100.56 117.636Z",
    fill: "#215759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.109 104.761L105.37 108.02L113.519 99.8711",
    stroke: "#2FF77A",
    strokeWidth: 2.44487,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5982 43.1961H35.7685C37.3847 43.1961 38.6948 41.886 38.6948 40.2698V34.4771C38.6948 32.861 37.3847 31.5508 35.7685 31.5508H29.5982C27.9821 31.5508 26.6719 32.861 26.6719 34.4771V40.2698C26.6719 41.886 27.9821 43.1961 29.5982 43.1961Z",
    fill: "#13F7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44563 108.818H16.3053C18.8878 108.818 20.9815 106.724 20.9815 104.142V94.8853C20.9815 92.3027 18.8878 90.209 16.3053 90.209H6.44563C3.86307 90.209 1.76953 92.3027 1.76953 94.8853V104.142C1.76953 106.724 3.86307 108.818 6.44563 108.818Z",
    fill: "#CEC2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5108_93694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146.643,
    height: 163.752,
    fill: "white",
    transform: "translate(0.484375 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f83b9f407f4ee9f710d6cf0cb305860e.svg";
export { ForwardRef as ReactComponent };